import { EXPORT_Route } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const ExportRoute = async (format, id) => {
  try {
    const resp = await apiClient.get(EXPORT_Route(format, id), {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
